import React, { useState } from "react";
import { connect } from "react-redux";
import AutorizacionActions from "../../../stores/autorizacion/Actions";
import Text from "../../../components/Common/Text";
import CustomSeparator from "../../../components/Common/CustomSeparator";
import CustomInput from "../../../components/CustomForm/CustomInput";
import CustomButton from "../../../components/CustomButton/CustomButton";
import {
  Form,
  FormWrapper,
  FormGroup,
} from "../../../components/CustomForm/FormStyles";
import useEmpresa from "../../../hooks/useEmpresa";
import Colors from "../../../themes/Colors";
import { getValueOrSuggestion } from "../../../utils/ObjectUtil";
import { Section } from "../../../components/CustomLayout/CustomLayoutStyles";

const ModificarDiagnosticoModal = (props) => {
  const {
    formAutorizacionDiagnosticoData,
    modificarDiagnosticoDefinitivoLoading,
    getDiagnosticosData,
    getDiagnosticosLoading,
  } = props;

  const empresa = useEmpresa();

  const [selectedDiagnostico, setSelectedDiagnostico] = useState(null);
  const [showRequired, setShowRequired] = useState(false);

  const modificarDiagnostico = () => {
    if (!formAutorizacionDiagnosticoData?.diagnostico) {
      setShowRequired(true);
      return;
    }

    let diagnosticoData = getValueOrSuggestion(
      selectedDiagnostico,
      formAutorizacionDiagnosticoData?.diagnostico
    );

    if (!diagnosticoData?.codigo) {
      diagnosticoData = getDiagnosticosData?.diagnosticos?.find(
        (item) =>
          item.descripcion === formAutorizacionDiagnosticoData?.diagnostico
      );

      if (!diagnosticoData) {
        props.formAutorizacionDiagnostico({
          ...formAutorizacionDiagnosticoData,
          alertConfig: {
            type: "info",
            title: "¡Hola!",
            message: "El diagnóstico digitado no existe en el sistema.",
            onConfirm: () => {
              props.formAutorizacionDiagnostico({
                ...formAutorizacionDiagnosticoData,
                showAlert: false,
              });
            },
          },
          showAlert: true,
        });

        return;
      }
    }

    props.modificarDiagnosticoDefinitivo({
      numeroAutorizacion:
        formAutorizacionDiagnosticoData?.diagnosticoModificar
          ?.numeroAutorizacion,
      diagnosticoDefinitivo:
        formAutorizacionDiagnosticoData?.diagnosticoModificar
          ?.diagnosticoMetaData?.esDiagnosticoDefinitivo,
      codigoDiagnostico: diagnosticoData?.codigo,
      diagnostico: formAutorizacionDiagnosticoData?.diagnostico,
      formAutorizacionDiagnosticoData,
      formHandler: props.formAutorizacionDiagnostico,
    });
  };

  const onStateChange =
    (key, format = null) =>
    (value) => {
      props.formAutorizacionDiagnostico({
        ...formAutorizacionDiagnosticoData,
        [key]: format ? format(value) : value,
      });
    };

  return (
    <div>
      <Text size="24px" isTittle={true} weight={"bold"}>
        {"Modificar Diagnóstico"}
      </Text>

      <Section align="center">
        <FormWrapper borderColor={empresa?.COLOR_PRINCIPAL}>
          <Form>
            <FormGroup>
              <CustomInput
                type={"text"}
                placeholder={"Diagnóstico"}
                label={"Diagnóstico"}
                value={formAutorizacionDiagnosticoData?.diagnostico}
                onChange={onStateChange("diagnostico")}
                required={true}
                showRequired={showRequired}
                suggestions={getDiagnosticosData?.diagnosticos || []}
                setSelectedSuggestion={setSelectedDiagnostico}
                dataLoading={getDiagnosticosLoading}
              />
            </FormGroup>
          </Form>
        </FormWrapper>
      </Section>

      <CustomSeparator height={"10px"} />

      <CustomButton
        label={"Modificar"}
        onClick={modificarDiagnostico}
        weight={"bold"}
        hoverColor={empresa?.COLOR_PRINCIPAL}
        bgColor={Colors.white}
        textColor={empresa?.COLOR_PRINCIPAL}
        border={`1px solid ${empresa?.COLOR_PRINCIPAL}`}
        isLoading={modificarDiagnosticoDefinitivoLoading}
      />
    </div>
  );
};

const mapStateToProps = (state) => ({
  authUserData: state.auth.authUserData,
  authUserLoading: state.auth.authUserLoading,
  authUserError: state.auth.authUserError,

  formAutorizacionDiagnosticoData:
    state.autorizacion.formAutorizacionDiagnosticoData,
  formAutorizacionDiagnosticoLoading:
    state.autorizacion.formAutorizacionDiagnosticoLoading,

  modificarDiagnosticoDefinitivoLoading:
    state.autorizacion.modificarDiagnosticoDefinitivoLoading,

  getDiagnosticosData: state.catalogo.getDiagnosticosData,
  getDiagnosticosLoading: state.catalogo.getDiagnosticosLoading,
});

const mapDispatchToProps = {
  formAutorizacionDiagnostico: AutorizacionActions.formAutorizacionDiagnostico,
  modificarDiagnosticoDefinitivo:
    AutorizacionActions.modificarDiagnosticoDefinitivo,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export default connector(ModificarDiagnosticoModal);
